module.exports = __webpack_public_path__ + "img/rang8.34339f48.png";